import { getCockpitFYearBounds } from './getCockpitFYearBounds'

export const clampCockpitFYear = (
  fYear: number,
  currentFYear: number,
  availableFYears: number[] = []
) => {
  const { minFYear, maxFYear } = getCockpitFYearBounds(currentFYear, availableFYears)
  return Math.min(Math.max(fYear, minFYear), maxFYear)
}
